import React from "react";
import { hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "../App";
import "../index.css";
import "../i18n/i18n";
import { initializePostHog } from "../lib/posthog";

// Initialize PostHog for client-side analytics
initializePostHog();

const container = document.getElementById("root");

if (container) {
  // Read SSR context from server-injected global
  const ssrContext = (window as typeof window & { __SSR_CONTEXT__?: unknown }).__SSR_CONTEXT__ || undefined;
  
  console.log('[Hydration] SSR context available:', !!ssrContext);
  if (ssrContext) {
    console.log('[Hydration] SSR context data:', {
      title: ssrContext.meta?.title,
      url: ssrContext.url,
      siteName: ssrContext.meta?.siteName
    });
  }

  hydrateRoot(
    container,
    <HelmetProvider>
      <BrowserRouter>
        <App isSSR={false} ssrContext={ssrContext} />
      </BrowserRouter>
    </HelmetProvider>
  );
}